var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIconFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66797C14.6023 1.66797 18.3332 5.3988 18.3332 10.0013C18.3332 14.6038 14.6023 18.3346 9.99984 18.3346C5.39734 18.3346 1.6665 14.6038 1.6665 10.0013C1.6665 5.3988 5.39734 1.66797 9.99984 1.66797ZM9.99984 5.0013C9.77882 5.0013 9.56686 5.0891 9.41058 5.24538C9.2543 5.40166 9.1665 5.61362 9.1665 5.83464V10.0013C9.16655 10.2223 9.25438 10.4342 9.41067 10.5905L11.9107 13.0905C12.0678 13.2423 12.2783 13.3263 12.4968 13.3244C12.7153 13.3225 12.9243 13.2348 13.0789 13.0803C13.2334 12.9258 13.321 12.7168 13.3229 12.4983C13.3248 12.2798 13.2408 12.0693 13.089 11.9121L10.8332 9.6563V5.83464C10.8332 5.61362 10.7454 5.40166 10.5891 5.24538C10.4328 5.0891 10.2209 5.0013 9.99984 5.0013Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconFilled);
export default __webpack_public_path__ + "static/media/ClockIconFilled.6423670576c78c9e6f908ef9f1bc4254.svg";
export { ForwardRef as ReactComponent };